module.exports = __webpack_public_path__ + "static/media/tips3-1-found.00ebeb09.png";